// External libraries
import styled from '@emotion/styled';
import { css } from '@emotion/core';

import { LABEL_COLOR } from '@/styles/styleVariables';

// CSS styles
const phoneInputStyleOverrides = {
  containerStyleOverrides: css`
    margin-bottom: 0;
  `,
  inputStyleOverrides: css`
    border-bottom-left-radius: 0;
    border-top-left-radius: 0;
  `,
};

// Styled components
const PhoneConfirmationText = styled.p`
  color: ${LABEL_COLOR};
  font-size: 14px;
  font-weight: normal;
  line-height: 1.2;
  margin: 6px 0 12px;
  white-space: normal;
`;

export { PhoneConfirmationText, phoneInputStyleOverrides };
